module.exports = __webpack_public_path__ + "media/images/shinagawa-diagnostics-logo@2x-c92b58eac2ae5dfed03f8306a624d47d.webp";